import React from "react";
import "./Home.css";
import Hero from "../Hero/Hero";
import BookingSections from "./BookingSections";
import usePageMeta from "../../hooks/usePageMeta";

const Home = () => {
  usePageMeta(
  "MakeBeeTrip - Flights, Hotels, Trains, Buses & Holiday Packages",
  "Book cheap flights, hotels, trains, buses, holiday packages & visa services on MakeBeeTrip. Compare prices, get exclusive deals and enjoy 24/7 travel support.",
  "makebeetrip, travel booking, flight booking, hotel booking, train tickets, bus tickets, holiday packages, visa services, cheap flights, travel deals, online travel agency india"
);
  return (
    <>
      <section>
        <Hero/>
        <BookingSections/>
    </section>
    
    </>
  
  );
};

export default Home;